// extracted by mini-css-extract-plugin
export default {"divider":"HorizontalDivider_divider__x5r5P"};